import clsx from "clsx";
import { ColumnInstance } from "react-table";

export const TableHeaderSelectFilter: React.FC<{
  choices: string[];
  column: ColumnInstance;
  className?: string;
}> = ({ choices, column, className }) => (
  <select
    className={clsx(
      "h-7 w-full flex-none rounded border-0 border-dm-charcoal-500 px-2 py-0 pr-7 text-sm shadow-none outline-none focus:border focus:ring-1 focus:ring-dm-charcoal-200",
      column.filterValue === undefined || column.filterValue === ""
        ? "text-dm-charcoal-500/50"
        : "text-dm-charcoal-500",
      className
    )}
    value={column.filterValue || ""}
    onClick={(e) => e.stopPropagation()}
    onChange={(e) => column.setFilter(e.target.value)}
  >
    <option value="">All</option>
    {choices.map((c) => (
      <option key={c} value={c}>
        {c}
      </option>
    ))}
  </select>
);
